import { Typography, Grid, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { BottomNavigation } from './bottomNavigation';
import { Formik, Form } from 'formik';
import { ACTIONS } from '@/components/layouts/layout.props';
import { RadioInput } from './radio';
import DesignSkillStackJson from '@/json/design-skill-stack/data.json';
import { FormPublicFieldFragment } from '@/graphql/fragment/form.public.fragment';

interface Question {
  category: number;
  questionId: string;
  slideNumber: number;
}

interface SubCategory {
  name: string;
  id: number;
  maxScore: number;
}

interface Category extends SubCategory {
  subCategories?: SubCategory[];
}

const QuestionSlide: any = ({
  design,
  fields,
  next,
  prev,
  slideIndex,
  lastSlideIndex,
  submissionCount,
  dispatch,
  totalQuestions,
  numberOfSlides,
  setSubmissionFlag,
}: any) => {
  const [initialValues, setInitialValues] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [SubCategoryName, setSubCategoryName] = useState('');

  useEffect(() => {
    const defaultValues = fields.map((field: FormPublicFieldFragment) => {
      return {
        [field.id]: JSON.parse(field.defaultValue),
      };
    });
    setInitialValues(defaultValues);

    const getFieldsFromJson = fields.map((field: FormPublicFieldFragment) => {
      return DesignSkillStackJson.questions.find(
        (question: Question) => question.questionId === field.id
      );
    });

    if (getFieldsFromJson && getFieldsFromJson.length) {
      const categoryData = DesignSkillStackJson.categories.find(
        (category: Category) => category.id === getFieldsFromJson[0].category
      );

      if (categoryData?.name) {
        setCategoryName(categoryData?.name);
      }

      if (categoryData?.subCategories) {
        const subCategoryData = categoryData.subCategories.find(
          (subCategory: SubCategory) =>
            subCategory.id === getFieldsFromJson[0].subCategory
        );

        if (subCategoryData?.name) {
          setSubCategoryName(subCategoryData?.name);
        }
      }
    }
  }, [fields]);

  const handleSaveField = (values: any) => {
    for (var index in fields) {
      const fieldObj = {
        field: fields[index].id,
        data: JSON.stringify(
          values[fields[index].id] !== undefined &&
            values[fields[index].id] !== null
            ? values[fields[index].id]
            : '-'
        ),
      };

      dispatch({
        type: ACTIONS.ADD_SUBMISSION,
        payload: fieldObj,
      });
    }

    if (slideIndex + 1 === numberOfSlides) {
      setSubmissionFlag(true);
    }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: '100%',
        margin: { md: '40px', sm: '20px' },
      }}
    >
      <Grid item>
        <Typography
          style={{
            color: design.colors.question,
            fontFamily: 'Open Sans',
            fontWeight: '700',
            fontSize: '20px',
            paddingTop: '30px',
          }}
        >
          {categoryName} {SubCategoryName !== '' ? `/ ${SubCategoryName}` : ''}
        </Typography>
        <Typography
          style={{
            color: 'rgba(255, 255, 255, 0.64)',
            fontFamily: 'Open Sans',
            fontSize: '16px',
          }}
        >
          Question {slideIndex} of {lastSlideIndex - 1}
        </Typography>
      </Grid>

      {initialValues && (
        <Formik
          initialValues={{
            ...initialValues,
            submissionCount: submissionCount,
          }}
          onSubmit={handleSaveField}
          enableReinitialize={true}
        >
          {({ values, handleChange, errors }) => (
            <Form
              className='form-slide'
              style={{ width: '100%', display: 'flex', margin: '0' }}
            >
              {fields.length && (
                <Grid
                  container
                  justifyContent='space-between'
                  sx={{ margin: '20px 0', width: '100%' }}
                >
                  <Grid item xs={12}>
                    <Box sx={{ margin: '10px' }}>
                      <RadioInput
                        field={fields[0]}
                        focus={false}
                        design={design}
                        next={next}
                        prev={prev}
                        slideIndex={1}
                        lastSlideIndex={lastSlideIndex}
                        handleChange={handleChange}
                        values={values}
                        errors={errors}
                        totalQuestions={totalQuestions}
                        questionType={1}
                        description='Choose the best option that best represents your level of knowledge on the topic.'
                        required={true}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: '50px' }}>
                    <Box sx={{ margin: '10px' }}>
                      <RadioInput
                        field={fields[1]}
                        focus={false}
                        design={design}
                        next={next}
                        prev={prev}
                        slideIndex={1}
                        lastSlideIndex={lastSlideIndex}
                        handleChange={handleChange}
                        values={values}
                        errors={errors}
                        totalQuestions={totalQuestions}
                        questionType={2}
                        description='Choose the best option that best represents your level of interest to learn about the topic.'
                        required={true}
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}
              <Grid
                container
                display='flex'
                maxWidth='xl'
                sx={{ alignItems: 'flex-start' }}
              >
                <BottomNavigation
                  errors={errors}
                  design={design}
                  next={next}
                  prev={prev}
                  slideIndex={slideIndex}
                  values={values}
                  lastSlideIndex={lastSlideIndex}
                  disableNext={
                    !values.hasOwnProperty(fields[0].id) ||
                    !values.hasOwnProperty(fields[1].id)
                  }
                />
              </Grid>
            </Form>
          )}
        </Formik>
      )}
    </Grid>
  );
};

export default QuestionSlide;
